module.exports = __webpack_public_path__ + "img/256.993b2137.jpg";